var _defs, _clipPath, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 27 27"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "lt_svg__a",
    cx: 13.5,
    cy: 13.5,
    r: 13
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "lt_svg__b"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#lt_svg__a",
    overflow: "visible"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#lt_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fdb913",
    d: "M-4.9-.1h37.3v9.2H-4.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006a44",
    d: "M-4.9 9.1h37.3v9.7H-4.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c1272d",
    d: "M-5.7 18.6h37.3v8.7H-5.7z"
  }))));
}

export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAyNS4yLjAsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iV2Fyc3R3YV8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCINCgkgdmlld0JveD0iMCAwIDI3IDI3IiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCAyNyAyNzsiIHhtbDpzcGFjZT0icHJlc2VydmUiPg0KPHN0eWxlIHR5cGU9InRleHQvY3NzIj4NCgkuc3Qwe2NsaXAtcGF0aDp1cmwoI1NWR0lEXzJfKTt9DQoJLnN0MXtmaWxsOiNGREI5MTM7fQ0KCS5zdDJ7ZmlsbDojMDA2QTQ0O30NCgkuc3Qze2ZpbGw6I0MxMjcyRDt9DQo8L3N0eWxlPg0KPGc+DQoJPGc+DQoJCTxkZWZzPg0KCQkJPGNpcmNsZSBpZD0iU1ZHSURfMV8iIGN4PSIxMy41IiBjeT0iMTMuNSIgcj0iMTMiLz4NCgkJPC9kZWZzPg0KCQk8Y2xpcFBhdGggaWQ9IlNWR0lEXzJfIj4NCgkJCTx1c2UgeGxpbms6aHJlZj0iI1NWR0lEXzFfIiAgc3R5bGU9Im92ZXJmbG93OnZpc2libGU7Ii8+DQoJCTwvY2xpcFBhdGg+DQoJCTxnIGNsYXNzPSJzdDAiPg0KCQkJPGc+DQoJCQkJPHJlY3QgeD0iLTQuOSIgeT0iLTAuMSIgY2xhc3M9InN0MSIgd2lkdGg9IjM3LjMiIGhlaWdodD0iOS4yIi8+DQoJCQk8L2c+DQoJCQk8Zz4NCgkJCQk8cmVjdCB4PSItNC45IiB5PSI5LjEiIGNsYXNzPSJzdDIiIHdpZHRoPSIzNy4zIiBoZWlnaHQ9IjkuNyIvPg0KCQkJPC9nPg0KCQkJPGc+DQoJCQkJPHJlY3QgeD0iLTUuNyIgeT0iMTguNiIgY2xhc3M9InN0MyIgd2lkdGg9IjM3LjMiIGhlaWdodD0iOC43Ii8+DQoJCQk8L2c+DQoJCTwvZz4NCgk8L2c+DQo8L2c+DQo8L3N2Zz4NCg==";
export { SvgLt as ReactComponent };